import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';

const srcCfg = { field:{label:'Saha',color:'bg-emerald-100 text-emerald-700'}, office:{label:'Ofis',color:'bg-blue-100 text-blue-700'}, referral:{label:'Referans',color:'bg-purple-100 text-purple-700'}, website:{label:'Web',color:'bg-orange-100 text-orange-700'} };
const ef = { full_name:'', company_name:'', phone:'', email:'', city:'', source:'office' };

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(ef);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetch_ = () => api.get('/customers', { params: search ? {search} : {} }).then(r => setCustomers(r.data));
  useEffect(() => { fetch_(); }, [search]);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post('/customers', form); setShowForm(false); setForm(ef); fetch_(); }
    catch (err) { const d = err.response?.data?.detail; alert('Hata: ' + (Array.isArray(d) ? d.map(x=>x.msg).join(', ') : d || 'Hata')); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-5 animate-fadein">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Musteriler</h1>
          <p className="text-gray-500 text-sm mt-0.5">{customers.length} kayitli musteri</p>
        </div>
        <div className="flex gap-2">
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Ara..."
            className="pl-4 pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-white w-48" />
          <button onClick={() => setShowForm(true)} className="btn-primary whitespace-nowrap">+ Yeni Musteri</button>
        </div>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowForm(false)}>
          <div className="modal animate-slideup">
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-lg font-bold">Yeni Musteri</h2>
              <button onClick={() => setShowForm(false)} className="text-gray-400 hover:text-gray-600">✕</button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input required value={form.full_name} onChange={e => setForm({...form, full_name:e.target.value})} className="input" placeholder="Ad Soyad *" />
              <input value={form.company_name} onChange={e => setForm({...form, company_name:e.target.value})} className="input" placeholder="Sirket" />
              <div className="grid grid-cols-2 gap-3">
                <input value={form.phone} onChange={e => setForm({...form, phone:e.target.value})} className="input" placeholder="Telefon" />
                <input value={form.email} onChange={e => setForm({...form, email:e.target.value})} className="input" placeholder="Email" />
                <input value={form.city} onChange={e => setForm({...form, city:e.target.value})} className="input" placeholder="Sehir" />
                <select value={form.source} onChange={e => setForm({...form, source:e.target.value})} className="input">
                  <option value="office">Ofis</option><option value="field">Saha</option>
                  <option value="referral">Referans</option><option value="website">Web</option>
                </select>
              </div>
              <div className="flex gap-2 pt-2">
                <button type="submit" disabled={loading} className="btn-primary flex-1">{loading ? 'Kaydediliyor...' : 'Ekle'}</button>
                <button type="button" onClick={() => setShowForm(false)} className="btn-secondary flex-1">Iptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="card overflow-hidden">
        <table className="w-full">
          <thead><tr className="bg-gray-50 border-b border-gray-100">
            <th className="table-header">Musteri</th>
            <th className="table-header hidden md:table-cell">Iletisim</th>
            <th className="table-header hidden lg:table-cell">Sehir</th>
            <th className="table-header">Kaynak</th>
            <th className="table-header text-right">Detay</th>
          </tr></thead>
          <tbody className="divide-y divide-gray-50">
            {customers.length === 0 ? (
              <tr><td colSpan="5" className="text-center py-12 text-gray-400">Henuz musteri yok</td></tr>
            ) : customers.map(c => (
              <tr key={c.id} className="hover:bg-gray-50/50 transition-colors cursor-pointer" onClick={() => navigate('/customers/' + c.id)}>
                <td className="table-cell">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold text-sm">{c.full_name[0].toUpperCase()}</div>
                    <div>
                      <div className="font-semibold text-gray-800 text-sm">{c.full_name}</div>
                      {c.company_name && <div className="text-xs text-gray-400">{c.company_name}</div>}
                    </div>
                  </div>
                </td>
                <td className="table-cell hidden md:table-cell text-sm text-gray-500">{c.phone || '-'}</td>
                <td className="table-cell hidden lg:table-cell text-sm text-gray-500">{c.city || '-'}</td>
                <td className="table-cell"><span className={"text-xs font-semibold px-2.5 py-1 rounded-full " + (srcCfg[c.source]?.color || 'bg-gray-100 text-gray-600')}>{srcCfg[c.source]?.label || c.source}</span></td>
                <td className="table-cell text-right"><button className="text-indigo-600 hover:text-indigo-800 text-xs font-semibold px-3 py-1.5 rounded-lg hover:bg-indigo-50">Detay →</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
